import customizer from './customizer';
import ugc from './ugc';
import embroidery from './embroidery';
import randomizer from './randomizer';
import ugcEntryPoint from './ugcEntryPoint';
import patternMaker from './patternmaker';
import checkerboard from './checkerboard';
import customsMonetateQ from './monetate';
import customsGTM from './gtm';

export default {
  customizer,
  ugc,
  embroidery,
  randomizer,
  ugcEntryPoint,
  patternMaker,
  checkerboard,
  customsMonetateQ,
  customsGTM
};
